<div [ngClass]="'data-processing ' + (this.service.showing ? 'show' : 'hide')">
  <img src="assets/img/oval.svg" class="loading-icon" />
</div>
